module.exports = {"title":"Tilde Ann Thurium","talk":"Pivoting to React, at scale","path":"/speakers/tilde-ann-thurium","type":"speaker","slug":"tilde-ann-thurium","twitter":"annthurium","github":"annthurium","companyWebsite":"https://www.pinterest.com","company":"Pinterest","body":"<p>In 2013, Pinterest built an in-house modular component framework on top of Backbone / Django.</p>\n<p>In 2016, we pivoted to using React.  Here are some obstacles we overcame to make our app faster and easier to reason about.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/tilde-ann-thurium.md
 ** module id = 552
 ** module chunks = 0
 **/